import AssetReportActions from './actions';

const INITIAL_STATE = {
  data: {},
  isProcessing: false,
  isError: false,
  errorMessage: [],
  form:{},
  isNewRecord:false,
  showModal:false,
  onSubmit:false,
  single:null,
  helperAssetReport:[],
  errorInternal:false,
  printAssetReport:null
};

function AssetReportReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case AssetReportActions.RESET_LIST:
      return { ...state,errorInternal:false,onSubmit:false, isProcessing: false,single:null, form:INITIAL_STATE.form,data:{}};
    case AssetReportActions.NEW_DATA:
      return { ...state,errorInternal:false,onSubmit:false, isProcessing: false,single:null, errorMessage:[],form:INITIAL_STATE.form,isNewRecord:true,showModal:true};
    case AssetReportActions.UPDATE_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, single:null,isNewRecord:false};
    case AssetReportActions.VIEW_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, single:action.payload,errorMessage:[],isNewRecord:false,showModal:true};
    case AssetReportActions.RESET_DATA:
      return { ...state,errorInternal:false,onSubmit:false, isProcessing: false, form:INITIAL_STATE.form,showModal:false};
    case AssetReportActions.DELETE_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, form:INITIAL_STATE.form,showModal:false};
    case AssetReportActions.ON_SUBMIT:
      return { ...state, errorInternal:false,onSubmit:true};
    case AssetReportActions.SHOW_DATA:
      return { ...state, errorInternal:false,onSubmit:false, isError: false, data: action.payload, errorMessage: [],isProcessing:false };
    case AssetReportActions.ERROR_DATA:
      return { ...state, errorInternal:false, isError: true,onSubmit:false,  errorMessage: action.payload,isProcessing:false };
    case AssetReportActions.SUCCESS_DATA:
      return { ...state,errorInternal:false,onSubmit:false, isError: false, showModal:false,form:INITIAL_STATE.form , onSubmit:false};
    case AssetReportActions.PROCESS_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: true, isError: false,isSuccess:false};
    case AssetReportActions.GET_HELPER_ASSETREPORT:
      return { ...state,errorInternal:false, isError: false,isSuccess:false,onSubmit:false,helperAssetReport:action.payload};
    case AssetReportActions.ERROR_SERVER:
      return { ...state,  isError: false, errorInternal:true, onSubmit:false,  errorMessage: action.payload, isProcessing:false };
    case AssetReportActions.BEFORE_PRINT_ASSETREPORT:
      return { ...state,errorInternal:false,  isError: false,isSuccess:false,onSubmit:false,printAssetReport:null,isProcessing:true};
    case AssetReportActions.PRINT_ASSETREPORT:
      return { ...state,errorInternal:false,  isError: false,isSuccess:false,onSubmit:false,printAssetReport:action.payload,isProcessing:false};
       
    default:
      return state;
    }
}

export default AssetReportReducer;
